var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Checkbox, FormControlLabel, Grid, ListItem, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get } from "../../../../api/api";
import { DeclinedJobReasonListUrl, getCustomerDeclinedJobswithPriceUrl, getDeclinedPmParts, getSavedPreviousDeclinedJobs, upsertPreviousAdditionalJobsAppointmentnURL, upsertPreviousAdditionalJobsEstimateURL, upsertPreviousAdditionalJobsInspectionURL } from "../../../../api/url";
import { ArrowDownIcon, ArrowUPIcon, BlueDropdownIcon, BlueUpIcon } from "../../../../assets/images";
import { MuiStack } from "../../../../components";
import { MuiLoaderButton } from "../../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../../components/atoms/sketeton";
import { EParentModuleName } from "../../../../constants";
import { showLoader, showNotification } from "../../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import useAnalyticsEventTracker from "../../../../utils/useAnalyticsEventTracker";
var DeclinedPMJobs = function (props) {
    var _pmParts$Labour4, _pmParts$Part4, _pmParts$Labour5, _pmParts$Labour6, _pmParts$Part5, _pmParts$Part6, _pmParts$Labour7, _pmParts$Part7, _pmParts$Part8, _pmParts$Labour8;
    var parentModuleName = props.parentModuleName, jobCount = props.jobCount, jobCardID = props.jobCardID, currentJobCardData = props.currentJobCardData, disabledPreviousDeclined = props.disabledPreviousDeclined, getSavedPeriodicPartsUrl = props.getSavedPeriodicPartsUrl;
    var _a = useParams(), estimateId = _a.estimateId, appointmentId = _a.appointmentId, inspectionId = _a.inspectionId;
    var _b = useState(false), isOpenSection = _b[0], setIsOpenSection = _b[1];
    var _c = useState([]), pmParts = _c[0], setPMParts = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var _e = useState(true), disableSaveBtn = _e[0], setDisableSaveBtn = _e[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _f = useState([]), currentJobCardDeclinedPmParts = _f[0], setCurrentJobCardDeclinedPmParts = _f[1];
    var _g = useState(false), skelaton = _g[0], setSkelaton = _g[1];
    var _h = useState({
        Labour: [],
        Part: []
    }), currentlySavedPeriodicParts = _h[0], setCurrentlySavedPeriodicParts = _h[1];
    var trackButtonClick = useAnalyticsEventTracker("DeclinedPMJobs");
    var dispatch = useAppDispatch();
    var savedPMParts = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }).savedPMParts;
    useEffect(function () {
        if (jobCardID) {
            setIsOpenSection(false);
        }
    }, [jobCardID]);
    useEffect(function () {
        getRejectRemarkList();
    }, []);
    useEffect(function () {
        if (jobCardID !== "" && jobCardID !== undefined) {
            getPMParts();
        }
    }, [jobCardID]);
    var getPMParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d, _currentJobCardData$d2, _currentJobCardData$d3, _response$payload, response, _response$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSkelaton(true);
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "declinedPreviousPMParts",
                            url: getCustomerDeclinedJobswithPriceUrl,
                            request: {
                                InstallBaseId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d = currentJobCardData.data) === null || _currentJobCardData$d === void 0 ? void 0 : _currentJobCardData$d.InstallBaseId,
                                ServiceDetailType: 3,
                                OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d2 = currentJobCardData.data) === null || _currentJobCardData$d2 === void 0 ? void 0 : _currentJobCardData$d2.OrganizationId,
                                VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d3 = currentJobCardData.data) === null || _currentJobCardData$d3 === void 0 ? void 0 : _currentJobCardData$d3.VinNo,
                                ParentId: jobCardID,
                                Entity: "JobCard"
                                // ParentId: "908a4257-835e-40b1-a83c-19e336bc3fd6",
                            }
                        }))];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) === 200)) return [3 /*break*/, 4];
                    setPMParts(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data);
                    return [4 /*yield*/, getSavedPMParts()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, getCurrentDeclinedPmParts()];
                case 3:
                    _a.sent();
                    setSkelaton(false);
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getCurrentDeclinedPmParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d4, _declinedPmPartsRespo, _declinedPmPartsRespo2, parentID, declineJobRequestBody, declinedPmPartsResponse, _declinedPmPartsRespo3, _declinedPmPartsRespo4, declinesPmParts, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    parentID = "";
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        parentID = estimateId;
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        parentID = appointmentId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        parentID = inspectionId;
                    }
                    declineJobRequestBody = {
                        "ParentId": parentID,
                        "InstallBaseId": currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d4 = currentJobCardData.data) === null || _currentJobCardData$d4 === void 0 ? void 0 : _currentJobCardData$d4.InstallBaseId,
                        "ServiceDetailType": 3
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: getDeclinedPmParts,
                            request: declineJobRequestBody
                        }))];
                case 1:
                    declinedPmPartsResponse = _a.sent();
                    if ((_declinedPmPartsRespo = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo !== void 0 && (_declinedPmPartsRespo = _declinedPmPartsRespo.value) !== null && _declinedPmPartsRespo !== void 0 && _declinedPmPartsRespo.success && (_declinedPmPartsRespo2 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo2 !== void 0 && (_declinedPmPartsRespo2 = _declinedPmPartsRespo2.value) !== null && _declinedPmPartsRespo2 !== void 0 && _declinedPmPartsRespo2.data) {
                        declinesPmParts = (_declinedPmPartsRespo3 = declinedPmPartsResponse.payload) !== null && _declinedPmPartsRespo3 !== void 0 && (_declinedPmPartsRespo3 = _declinedPmPartsRespo3.value) !== null && _declinedPmPartsRespo3 !== void 0 && _declinedPmPartsRespo3.data ? (_declinedPmPartsRespo4 = declinedPmPartsResponse.payload) === null || _declinedPmPartsRespo4 === void 0 || (_declinedPmPartsRespo4 = _declinedPmPartsRespo4.value) === null || _declinedPmPartsRespo4 === void 0 ? void 0 : _declinedPmPartsRespo4.data : [];
                        setCurrentJobCardDeclinedPmParts(declinesPmParts);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getSavedPMParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d5, _currentJobCardData$d6, _currentJobCardData$d7, _SavedPmPartsResponse, _SavedPmPartsResponse2, _SavedPmPartsResponse3, _SavedPmPartsResponse4, _currentJobCardData$d8, _currentJobCardData$d9, _response, _response2, requestBody, SavedPmPartsResponse, savedLabour, saveParts, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        RepairTypeId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d5 = currentJobCardData.data) === null || _currentJobCardData$d5 === void 0 ? void 0 : _currentJobCardData$d5.RepairTypeId,
                        VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d6 = currentJobCardData.data) === null || _currentJobCardData$d6 === void 0 ? void 0 : _currentJobCardData$d6.VinNo,
                        OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d7 = currentJobCardData.data) === null || _currentJobCardData$d7 === void 0 ? void 0 : _currentJobCardData$d7.OrganizationId
                    };
                    if (parentModuleName === EParentModuleName.Appointment) {
                        requestBody.AppointmentId = appointmentId;
                    }
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        requestBody.EstimateId = estimateId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        requestBody.InspectionId = inspectionId;
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: getSavedPeriodicPartsUrl,
                            request: requestBody
                        }))];
                case 1:
                    SavedPmPartsResponse = _a.sent();
                    savedLabour = (_SavedPmPartsResponse = SavedPmPartsResponse === null || SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse2 = SavedPmPartsResponse.payload) === null || _SavedPmPartsResponse2 === void 0 || (_SavedPmPartsResponse2 = _SavedPmPartsResponse2.data) === null || _SavedPmPartsResponse2 === void 0 || (_SavedPmPartsResponse2 = _SavedPmPartsResponse2.PeriodicParts) === null || _SavedPmPartsResponse2 === void 0 ? void 0 : _SavedPmPartsResponse2.Labour) !== null && _SavedPmPartsResponse !== void 0 ? _SavedPmPartsResponse : [];
                    saveParts = (_SavedPmPartsResponse3 = SavedPmPartsResponse === null || SavedPmPartsResponse === void 0 || (_SavedPmPartsResponse4 = SavedPmPartsResponse.payload) === null || _SavedPmPartsResponse4 === void 0 || (_SavedPmPartsResponse4 = _SavedPmPartsResponse4.data) === null || _SavedPmPartsResponse4 === void 0 || (_SavedPmPartsResponse4 = _SavedPmPartsResponse4.PeriodicParts) === null || _SavedPmPartsResponse4 === void 0 ? void 0 : _SavedPmPartsResponse4.Part) !== null && _SavedPmPartsResponse3 !== void 0 ? _SavedPmPartsResponse3 : [];
                    setCurrentlySavedPeriodicParts({
                        Labour: savedLabour,
                        Part: saveParts
                    });
                    request = {
                        // RepairTypeId: currentJobCardData?.data?.RepairTypeId,
                        ServiceDetailType: 3,
                        JobSource: "PreviousDeclined",
                        OrganizationId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d8 = currentJobCardData.data) === null || _currentJobCardData$d8 === void 0 ? void 0 : _currentJobCardData$d8.OrganizationId,
                        VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d9 = currentJobCardData.data) === null || _currentJobCardData$d9 === void 0 ? void 0 : _currentJobCardData$d9.VinNo
                    };
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedPMParts",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: estimateId,
                                Entity: "Estimate"
                            })
                        }))];
                case 2:
                    response = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedPMParts",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: appointmentId,
                                Entity: "Appointment"
                            })
                        }))];
                case 4:
                    response = _a.sent();
                    _a.label = 5;
                case 5:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedPMParts",
                            url: getSavedPreviousDeclinedJobs,
                            request: _objectSpread(_objectSpread({}, request), {}, {
                                PreJobCardDocumentId: inspectionId,
                                Entity: "Inspection"
                            })
                        }))];
                case 6:
                    response = _a.sent();
                    _a.label = 7;
                case 7:
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && _response.value.success && ((_response2 = response) === null || _response2 === void 0 || (_response2 = _response2.payload) === null || _response2 === void 0 ? void 0 : _response2.value.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var updateData = function (item, type) {
        if (type === "Labour") {
            var _pmParts$Labour;
            var _data = pmParts === null || pmParts === void 0 || (_pmParts$Labour = pmParts.Labour) === null || _pmParts$Labour === void 0 ? void 0 : _pmParts$Labour.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setPMParts(_objectSpread(_objectSpread({}, pmParts), {}, {
                Labour: __spreadArray([], _data, true)
            }));
        }
        if (type === "Part") {
            var _pmParts$Part;
            var _data = pmParts === null || pmParts === void 0 || (_pmParts$Part = pmParts.Part) === null || _pmParts$Part === void 0 ? void 0 : _pmParts$Part.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setPMParts(_objectSpread(_objectSpread({}, pmParts), {}, {
                Part: __spreadArray([], _data, true)
            }));
        }
    };
    var onGroupChange = function (e, item, type) {
        if (type === "Part") {
            var _pmParts$Part2;
            var _data = pmParts === null || pmParts === void 0 || (_pmParts$Part2 = pmParts.Part) === null || _pmParts$Part2 === void 0 ? void 0 : _pmParts$Part2.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isSelected: !(i !== null && i !== void 0 && i.isSelected)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setPMParts(_objectSpread(_objectSpread({}, pmParts), {}, {
                Part: __spreadArray([], _data, true)
            }));
        }
        if (type === "Labour") {
            var _pmParts$Labour2;
            var _data = pmParts === null || pmParts === void 0 || (_pmParts$Labour2 = pmParts.Labour) === null || _pmParts$Labour2 === void 0 ? void 0 : _pmParts$Labour2.map(function (i, index) {
                if ((item === null || item === void 0 ? void 0 : item.ChildId) === (i === null || i === void 0 ? void 0 : i.ChildId)) {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isSelected: !(i !== null && i !== void 0 && i.isSelected)
                    });
                    return _i;
                }
                else {
                    return i;
                }
            });
            setPMParts(_objectSpread(_objectSpread({}, pmParts), {}, {
                Labour: __spreadArray([], _data, true)
            }));
        }
        setDisableSaveBtn(false);
    };
    var upsertPmParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _pmParts$Part3, _pmParts$Labour3, _response3, _response4, partList, labourList, standardPartArray, standardLabourArray, payload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Declined_PMParts_Save", undefined);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    partList = pmParts === null || pmParts === void 0 || (_pmParts$Part3 = pmParts.Part) === null || _pmParts$Part3 === void 0 ? void 0 : _pmParts$Part3.filter(function (item) { return item.isSelected; });
                    labourList = pmParts === null || pmParts === void 0 || (_pmParts$Labour3 = pmParts.Labour) === null || _pmParts$Labour3 === void 0 ? void 0 : _pmParts$Labour3.filter(function (item) { return item.isSelected; });
                    standardPartArray = [];
                    standardLabourArray = [];
                    return [4 /*yield*/, (labourList === null || labourList === void 0 ? void 0 : labourList.forEach(function (elem) {
                            var objLabour = {};
                            objLabour["Quantity"] = elem.Quantity !== null ? elem.Quantity : 1;
                            objLabour["SystemName"] = "Labour";
                            objLabour["ChildId"] = elem.ChildId;
                            objLabour['JobSource'] = 'PreviousDeclined';
                            objLabour['ServiceDetailType'] = 3;
                            standardLabourArray.push(_objectSpread({}, objLabour));
                        }))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, (partList === null || partList === void 0 ? void 0 : partList.forEach(function (elem) {
                            var objPart = {};
                            objPart["Quantity"] = elem.Quantity !== null ? elem.Quantity : 1;
                            objPart["SystemName"] = "Product";
                            objPart["ChildId"] = elem.ChildId;
                            objPart['JobSource'] = 'PreviousDeclined';
                            objPart['ServiceDetailType'] = 3;
                            standardLabourArray.push(_objectSpread({}, objPart));
                        }))];
                case 2:
                    _a.sent();
                    payload = {};
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        // RepairTypeId: currentJobCardData?.data?.RepairTypeId,
                        AdditionalJobs: __spreadArray(__spreadArray([], standardLabourArray, true), standardPartArray, true)
                    });
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 4];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        EstimateId: estimateId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsEstimateURL,
                            request: payload
                        }))];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 6];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        AppointmentId: appointmentId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsAppointmentnURL,
                            request: payload
                        }))];
                case 5:
                    response = _a.sent();
                    _a.label = 6;
                case 6:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 8];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        InspectionId: inspectionId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsInspectionURL,
                            request: payload
                        }))];
                case 7:
                    response = _a.sent();
                    _a.label = 8;
                case 8:
                    if ((_response3 = response) !== null && _response3 !== void 0 && (_response3 = _response3.payload) !== null && _response3 !== void 0 && (_response3 = _response3.value) !== null && _response3 !== void 0 && _response3.success && ((_response4 = response) === null || _response4 === void 0 || (_response4 = _response4.payload) === null || _response4 === void 0 || (_response4 = _response4.value) === null || _response4 === void 0 ? void 0 : _response4.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        getSavedPMParts();
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Periodic parts saved successfully",
                            type: "success"
                        }));
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    setDisableSaveBtn(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var getReason = function (option) {
        var i = rejectReasonRemarkList === null || rejectReasonRemarkList === void 0 ? void 0 : rejectReasonRemarkList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId); });
        if (i)
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                id: "Name",
                variant: "body2"
            }, i === null || i === void 0 ? void 0 : i.Name), /*#__PURE__*/ React.createElement(Typography, {
                id: "Remarks",
                variant: "body2",
                color: "text.secondary"
            }, (option === null || option === void 0 ? void 0 : option.Remarks) !== "" ? option === null || option === void 0 ? void 0 : option.Remarks : "-", " "));
    };
    var disablePart = function (option) {
        var _savedPMParts$data;
        var _find = savedPMParts === null || savedPMParts === void 0 || (_savedPMParts$data = savedPMParts.data) === null || _savedPMParts$data === void 0 || (_savedPMParts$data = _savedPMParts$data.Part) === null || _savedPMParts$data === void 0 ? void 0 : _savedPMParts$data.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInSaved = currentlySavedPeriodicParts.Part.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInCurrentJCDeclined = currentJobCardDeclinedPmParts.find(function (item) { return item.ChildId === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_find !== null && _find !== void 0 && _find.ChildId || _foundInCurrentJCDeclined || _foundInSaved) {
            return true;
        }
        else {
            return false;
        }
    };
    var disableLabour = function (option) {
        var _savedPMParts$data2;
        var _foundInCurrentJCSaved = savedPMParts === null || savedPMParts === void 0 || (_savedPMParts$data2 = savedPMParts.data) === null || _savedPMParts$data2 === void 0 || (_savedPMParts$data2 = _savedPMParts$data2.Labour) === null || _savedPMParts$data2 === void 0 ? void 0 : _savedPMParts$data2.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInSaved = currentlySavedPeriodicParts.Labour.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInCurrentJCDeclined = currentJobCardDeclinedPmParts.find(function (item) { return item.ChildId === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_foundInCurrentJCSaved !== null && _foundInCurrentJCSaved !== void 0 && _foundInCurrentJCSaved.ChildId || _foundInCurrentJCDeclined || _foundInSaved) {
            return true;
        }
        else {
            return false;
        }
    };
    var getLabourChecked = function (option) {
        var _savedPMParts$data3;
        var _foundInCurrentJCSaved = savedPMParts === null || savedPMParts === void 0 || (_savedPMParts$data3 = savedPMParts.data) === null || _savedPMParts$data3 === void 0 || (_savedPMParts$data3 = _savedPMParts$data3.Labour) === null || _savedPMParts$data3 === void 0 ? void 0 : _savedPMParts$data3.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInSaved = currentlySavedPeriodicParts.Labour.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_foundInCurrentJCSaved !== null && _foundInCurrentJCSaved !== void 0 && _foundInCurrentJCSaved.ChildId || _foundInSaved) {
            return true;
        }
        else {
            return false;
        }
    };
    var getPartChecked = function (option) {
        var _savedPMParts$data4;
        var _find = savedPMParts === null || savedPMParts === void 0 || (_savedPMParts$data4 = savedPMParts.data) === null || _savedPMParts$data4 === void 0 || (_savedPMParts$data4 = _savedPMParts$data4.Part) === null || _savedPMParts$data4 === void 0 ? void 0 : _savedPMParts$data4.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        var _foundInSaved = currentlySavedPeriodicParts.Part.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ChildId) === (option === null || option === void 0 ? void 0 : option.ChildId); });
        if (_find !== null && _find !== void 0 && _find.ChildId || _foundInSaved) {
            return true;
        }
        else {
            return false;
        }
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid #AFD5FF",
            borderRadius: "12px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: "flex",
        padding: 2,
        borderBottom: isOpenSection ? "1px solid #DEE4EB" : "",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, t("Periodic maintenance"), " "), /*#__PURE__*/ React.createElement(Typography, {
        id: "PM-Count",
        sx: {
            backgroundColor: "#EEF6FF",
            padding: "3px 8px",
            borderRadius: "12px",
            border: "1px solid #AFD5FF",
            justifyContent: "center",
            color: "#3697FF",
            ml: "5px"
        },
        variant: "subtitle2"
    }, jobCount)), /*#__PURE__*/ React.createElement(MuiStack, null, isOpenSection ? /*#__PURE__*/ React.createElement("img", {
        src: ArrowUPIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "DeclinedPMSColseClick", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }) : /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "DeclinedPMSOpenClick", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }))), isOpenSection && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        display: "flex"
    }, ((pmParts === null || pmParts === void 0 || (_pmParts$Labour4 = pmParts.Labour) === null || _pmParts$Labour4 === void 0 ? void 0 : _pmParts$Labour4.length) > 0 || (pmParts === null || pmParts === void 0 || (_pmParts$Part4 = pmParts.Part) === null || _pmParts$Part4 === void 0 ? void 0 : _pmParts$Part4.length) > 0) && !skelaton ? /*#__PURE__*/ React.createElement(React.Fragment, null, (pmParts === null || pmParts === void 0 || (_pmParts$Labour5 = pmParts.Labour) === null || _pmParts$Labour5 === void 0 ? void 0 : _pmParts$Labour5.length) > 0 && (pmParts === null || pmParts === void 0 || (_pmParts$Labour6 = pmParts.Labour) === null || _pmParts$Labour6 === void 0 ? void 0 : _pmParts$Labour6.map(function (option) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: 'row',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            id: "Labour-Container",
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option, "Labour");
            },
            disabled: disabledPreviousDeclined || disableLabour(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                id: "periodic-part-checkbox",
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || getLabourChecked(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.LabourName,
            sx: {
                padding: "0px",
                fontWeight: 500,
                fontSize: "14px"
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            marginLeft: 3
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "Labour-Code",
            variant: "h6",
            color: 'secondary'
        }, option !== null && option !== void 0 && option.PartCode ? "#".concat(option === null || option === void 0 ? void 0 : option.PartCode) : '-'))), /*#__PURE__*/ React.createElement(Typography, {
            id: "Labour-Type",
            sx: {
                backgroundColor: "#F4F7FA",
                padding: "3px 8px",
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                color: "#1B1D21",
                ml: "5px"
            },
            variant: "subtitle2"
        }, "L"))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex",
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t('REASON')), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            id: "BlueUpIcon-Labour",
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "Labour"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            id: "BlueDropdownIcon-Labour",
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "Labour"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1,
                ml: 6,
                mr: 2
            }
        }, getReason(option))));
    })), (pmParts === null || pmParts === void 0 || (_pmParts$Part5 = pmParts.Part) === null || _pmParts$Part5 === void 0 ? void 0 : _pmParts$Part5.length) > 0 && (pmParts === null || pmParts === void 0 || (_pmParts$Part6 = pmParts.Part) === null || _pmParts$Part6 === void 0 ? void 0 : _pmParts$Part6.map(function (option) {
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                justifyContent: "space-between",
                alignItems: "center"
            }
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center",
                flexDirection: 'row',
                justifyContent: 'space-between'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            id: "Part-Cont",
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option, "Part");
            },
            disabled: disabledPreviousDeclined || disablePart(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                id: "periodic-part-checkbox",
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || getPartChecked(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.PartName,
            sx: {
                padding: "0px",
                fontWeight: 500,
                fontSize: "14px"
            }
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            marginLeft: 3
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "PM-Part-Code",
            variant: "h6",
            color: 'secondary'
        }, option !== null && option !== void 0 && option.PartCode ? "#".concat(option === null || option === void 0 ? void 0 : option.PartCode) : '-'))), /*#__PURE__*/ React.createElement(Typography, {
            id: "PM-Item-Type",
            sx: {
                backgroundColor: "#F4F7FA",
                padding: "3px 8px",
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "flex-end",
                color: "#1B1D21",
                ml: "5px"
            },
            variant: "subtitle2"
        }, "P"))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex",
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t('REASON')), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            id: "BlueUpIcon",
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "Part"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            id: "BlueDropdownIcon",
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "Part"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1,
                ml: 6,
                mr: 2
            }
        }, getReason(option))));
    }))) :
        // 
        skelaton ? /*#__PURE__*/ React.createElement(MuiStack, {
            style: {
                padding: '16px 16px 8px 16px',
                height: '70px'
            },
            width: "100%",
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(MuiStack, {
            paddingTop: 1,
            width: "100%",
            justifyContent: "center",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "prev-declined-no-data",
            variant: "h2"
        }, t("No Data Found"), "..!!")))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            marginX: 2,
            paddingTop: 2,
            borderBottom: "1px solid #DEE4EB"
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: "flex",
            justifyContent: "end",
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        disabled: disabledPreviousDeclined || (pmParts === null || pmParts === void 0 || (_pmParts$Labour7 = pmParts.Labour) === null || _pmParts$Labour7 === void 0 ? void 0 : _pmParts$Labour7.length) <= 0 && (pmParts === null || pmParts === void 0 || (_pmParts$Part7 = pmParts.Part) === null || _pmParts$Part7 === void 0 ? void 0 : _pmParts$Part7.length) <= 0 || (pmParts === null || pmParts === void 0 || (_pmParts$Part8 = pmParts.Part) === null || _pmParts$Part8 === void 0 || (_pmParts$Part8 = _pmParts$Part8.filter(function (item) { return item.isSelected; })) === null || _pmParts$Part8 === void 0 ? void 0 : _pmParts$Part8.length) <= 0 && (pmParts === null || pmParts === void 0 || (_pmParts$Labour8 = pmParts.Labour) === null || _pmParts$Labour8 === void 0 || (_pmParts$Labour8 = _pmParts$Labour8.filter(function (item) { return item.isSelected; })) === null || _pmParts$Labour8 === void 0 ? void 0 : _pmParts$Labour8.length) <= 0 || disableSaveBtn,
        color: "primary",
        onClick: function () {
            upsertPmParts();
        },
        name: t("Save")
    }))));
};
export default DeclinedPMJobs;
